import { Box, Paper, Stack, Typography } from '@mui/material';
import { useId, type ReactNode } from 'react';

export type PageControlsBarProps = {
  label: string;
  children: ReactNode;
};

export const PageControlsBar = ({ label, children }: PageControlsBarProps) => {
  const labelId = useId();

  return (
    <Paper
      component="section"
      variant="outlined"
      elevation={0}
      aria-labelledby={labelId}
      data-testid="page-controls-bar"
      sx={{ borderColor: 'divider', color: 'text.primary', mb: 3, p: 2 }}
    >
      <Stack
        data-testid="page-controls-bar-layout"
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ alignItems: { sm: 'center' }, justifyContent: 'space-between' }}
      >
        <Typography id={labelId} component="h2" variant="subtitle1" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
        <Box
          data-testid="page-controls-bar-controls"
          sx={{
            display: 'flex',
            width: { xs: '100%', sm: 'auto' },
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            flexWrap: 'wrap',
            gap: 1,
            '& > *': { width: { xs: '100%', sm: 'auto' } },
          }}
        >
          {children}
        </Box>
      </Stack>
    </Paper>
  );
};
